import gtm from 'eco-design-reliance/gtm';
import EcoNavPage from 'eco-design/sections/eco-nav-page';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useProductPageStatus } from '../../ProductProvider';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function FixTab() {
    const { t } = useLang('rapidseries.tab');
    const { locale = 'us' } = useRouter();

    const pageStatus = useProductPageStatus();
    const IS_JP_V2 = !['statusA', 'statusB'].includes(pageStatus) && locale === 'jp';
    const IS_NA = ['us', 'ca'].includes(locale);

    const itemsA = IS_NA
        ? [
              {
                  title: t('rapid_mag'),
                  href: '#Screen3',
              },
              {
                  title: t('rapid_pro'),
                  href: '#Screen1',
              },
              {
                  title: t('rapid'),
                  href: '#Screen2',
              },
          ]
        : [
              IS_JP_V2
                  ? {
                        title: t('rapid_mag'),
                        href: '#Screen3',
                    }
                  : {
                        title: t('rapid_pro'),
                        href: '#Screen1',
                    },
              {
                  title: t('rapid'),
                  href: '#Screen2',
              },
              IS_JP_V2
                  ? {
                        title: t('rapid_pro'),
                        href: '#Screen1',
                    }
                  : {
                        title: t('rapid_mag'),
                        href: '#Screen3',
                    },
          ];
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const screen1 = IS_JP_V2 || IS_NA ? document.getElementById('Screen3') : document.getElementById('Screen1');
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 0) {
                    document.getElementById('NavPage')?.classList.add('active');
                } else {
                    document.getElementById('NavPage')?.classList.remove('active');
                }
            }
        };
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, [IS_JP_V2, IS_NA]);

    return (
        <div className={`${css.comp} FixTab GtmModuleData-section`} data-section-id="Rapid-Series-FixTab" id="NavPage">
            <EcoNavPage
                items={itemsA}
                openGTM={false}
                onClick={(item: any, index: number) => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'product_navigation',
                        navigation_name: item.title,
                        product_name: 'EcoFlow RAPID Series',
                        __btn_id1: `FixTab .nav-tab-${index + 1}`,
                        __btn_id2: `nav-tab-${index + 1}`,
                        __btn_type: 'common',
                    });
                }}
            />
        </div>
    );
}
